import { render, staticRenderFns } from "./Notifications.html?vue&type=template&id=b7e8addc&scoped=true&external"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=b7e8addc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e8addc",
  null
  
)

export default component.exports